import fetchAPI from '../utils/service';

function getUsersListRequest() {
  return {
    type: 'GET_USERS_LIST_REQUEST',
  };
}
function getUsersListSuccess(payload) {
  return {
    type: 'GET_USERS_LIST_SUCCESS',
    payload,
  };
}
function getUsersListFailure() {
  return {
    type: 'GET_USERS_LIST_FAILURE',
  };
}

function getUsersList({ limit, skip }) {
  return async (dispatch) => {
    dispatch(getUsersListRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/user/',
        params: { limit, skip },
      });
      if (res.status === 200) {
        dispatch(getUsersListSuccess(res.data));
      } else {
        dispatch(getUsersListFailure());
      }
    } catch (error) {
      dispatch(getUsersListFailure());
    }
  };
}

function getLecturerListRequest() {
  return {
    type: 'GET_LECTURER_LIST_REQUEST',
  };
}
function getLecturerListSuccess(payload) {
  return {
    type: 'GET_LECTURER_LIST_SUCCESS',
    payload,
  };
}
function getLecturerListFailure() {
  return {
    type: 'GET_LECTURER_LIST_FAILURE',
  };
}

function getLecturerList() {
  return async (dispatch) => {
    dispatch(getLecturerListRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/user/lecturer',
      });
      if (res.status === 200) {
        dispatch(getLecturerListSuccess(res.data));
      } else {
        dispatch(getLecturerListFailure());
      }
    } catch (error) {
      dispatch(getLecturerListFailure());
    }
  };
}

function createUserRequest() {
  return {
    type: 'CREATE_USER_REQUEST',
  };
}
function createUserSuccess(data) {
  return {
    type: 'CREATE_USER_SUCCESS',
    payload: {
      data,
    },
  };
}
function createUserFailure() {
  return {
    type: 'CREATE_USER_FAILURE',
  };
}

function createUser({ data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(createUserRequest());
    try {
      const res = await fetchAPI({
        method: 'POST',
        data,
        endpoints: '/user/register',
      });
      if (res.status === 201) {
        dispatch(createUserSuccess(res.data));
        response.success();
      } else {
        dispatch(createUserFailure());
        response.failure();
      }
    } catch (error) {
      dispatch(createUserFailure());
      response.failure();
    }
  };
}

function editUserRequest() {
  return {
    type: 'EDIT_USER_REQUEST',
  };
}
function editUserSuccess(data, lecturerId) {
  return {
    type: 'EDIT_USER_SUCCESS',
    payload: {
      data,
      lecturerId,
    },
  };
}
function editUserFailure() {
  return {
    type: 'EDIT_USER_FAILURE',
  };
}

function editUser({ lecturerId, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(editUserRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/user/${lecturerId}`,
      });
      if (res.status === 200) {
        dispatch(editUserSuccess(res.data, lecturerId));
        response.success();
      } else {
        dispatch(editUserFailure());
        response.failure();
      }
    } catch (error) {
      dispatch(editUserFailure());
      response.failure();
    }
  };
}

function deleteUserRequest() {
  return {
    type: 'DELETE_USER_REQUEST',
  };
}
function deleteUserSuccess(lecturerId) {
  return {
    type: 'DELETE_USER_SUCCESS',
    payload: {
      lecturerId,
    },
  };
}
function deleteUserFailure() {
  return {
    type: 'DELETE_USER_FAILURE',
  };
}

function deleteUser({ lecturerId, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(deleteUserRequest());
    try {
      const res = await fetchAPI({
        method: 'DELETE',
        endpoints: `/user/${lecturerId}`,
      });
      if (res.status === 200) {
        dispatch(deleteUserSuccess(lecturerId));
        response.success();
      } else {
        dispatch(deleteUserFailure());
        response.failure();
      }
    } catch (error) {
      dispatch(deleteUserFailure());
      response.failure();
    }
  };
}

function changeCurrentUserPage(page) {
  return {
    type: 'CHANGE_CURRENT_USER_PAGE',
    payload: page,
  };
}

function logoutUsers() {
  return {
    type: 'LOGOUT',
  };
}

export {
  getUsersList,
  changeCurrentUserPage,
  getLecturerList,
  createUser,
  editUser,
  deleteUser,
  logoutUsers,
};



// WEBPACK FOOTER //
// ./src/actions/users.js